import styles from "./ProjectsScreen.module.css";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
import Contact from "../../components/Contact/Contact";
import projects from "../../data";
import { Link } from "react-router-dom";
function ProjectsScreen() {
  function truncateText(text, maxWords) {
    const words = text.split(" ");
    const excerpt = words.slice(0, maxWords).join(" ");

    // Add ellipsis (...) if the excerpt is shorter than the original text
    if (words.length > maxWords) {
      return excerpt + "...";
    } else {
      return excerpt;
    }
  }

  return (
    <main>
      <Navbar />
      <div className={styles.main}>
        <h1> Some Projects I Have Worked On</h1>
      </div>
      <div className={styles.container}>
        <div className={styles.cardContainer}>
          {projects.map(project => (
            <div key={project.id} className={styles.card}>
              <div className="imgContainer">
                <img
                  src={process.env.PUBLIC_URL + project.img}
                  loading="lazy"
                  alt="img"
                />
              </div>
              <h6>{project.title}</h6>
              <p>
                {truncateText(project.desc, 16)}
                <Link to={`/project/${project.id}`}>
                  <span> Read More &rsaquo; </span>
                </Link>
              </p>
              <div className={styles.linksContainer}>
                <a href={project.link} className={styles.cardFirstChild}>
                  View Project
                </a>
                {project.sourceCode ? (
                  <a
                    href={project.sourceLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.cardSecondChild}
                  >
                    Source Code
                  </a>
                ) : (
                  ""
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Contact />
      <Footer />
    </main>
  );
}

export default ProjectsScreen;
